import { preloadDraft } from '@confluence/fabric-providers/entry-points/preloadDraft.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { expValEquals } from '@confluence/feature-experiments';

export async function preloadEditPageRoutePostSSR(match: RouteMatch, _url: string): Promise<void> {
	const { contentId } = match.params;
	// draftShareId is a query param, not a route param
	const draftShareId = expValEquals(
		'cc_perms_fix_blog_draft_restricted_page_showing',
		'isEnabled',
		true,
	)
		? match.query?.draftShareId
		: match.params.draftShareId;

	await preloadDraft(contentId, Array.isArray(draftShareId) ? draftShareId[0] : draftShareId);
}
